import {useCallback} from 'react';
import {t} from '../../../localization';
import {
  TeamMember,
  useMembershipsOperations,
  useSnacksActions,
  useTeam,
} from '../../../services';
import {useAlertTask} from '../../modals';

export const useRemoveMembership = (teamId: number) => {
  const showAlert = useAlertTask();
  const team = useTeam(teamId);
  const {remove: removeMembership} = useMembershipsOperations();
  const {add: addSnack} = useSnacksActions();

  return useCallback(
    (member: TeamMember) => {
      const memberName = member
        ? member.firstName
          ? member.firstName + ' ' + member.lastName
          : member.mobileNo
        : '';

      showAlert({
        okButtonTitle: t('screens.members.removepeopledialog.removeButton'),
        okButtonKind: 'Negative',
        title: t('screens.members.removepeopledialog.title', {
          name: memberName,
        }),
        body: t('screens.members.removepeopledialog.subtitle'),
        cancelButtonTitle: t('general.cancel'),
      }).then(result => {
        if (result) {
          addSnack(
            t('screens.members.snacks.memberremoved', {
              team: team?.name ?? '',
              member: memberName,
            }),
          );
          removeMembership(member.membershipId);
        }
      });
    },
    [addSnack, removeMembership, showAlert, team?.name],
  );
};
